module.exports = __webpack_public_path__ + "static/media/ic_searchtype_port.0a2bbd77.svg";